import React, { useState, useEffect } from "react";
import {
  updateProfile,
  signInWithPopup,
  signInWithEmailAndPassword,
} from "firebase/auth";
import {
  fetchSignInMethodsForEmail,
  linkWithCredential,
  FacebookAuthProvider,
} from "firebase/auth";
import { auth, googleProvider, facebookProvider } from "../FirebaseConfig";
import WebFont from "webfontloader";
import { Link, redirect, useNavigate, useSearchParams } from "react-router-dom";
import { UserAuth } from "../Context";
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";
import useUserStore from "../StatesStore/UserStore";
import { toastOptions } from "../lib/toastOptions";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { generateReferralCode } from "../lib/generateReferralCode";
import { handleInvite } from "../Referral/HandleInvite";
import TermsAndConditions from "./TermsAndConditions";
import { Button } from "react-bootstrap";
import { WelcomeUser } from "../EmailSystem/sendEmails";
import useUrlState from "../StatesStore/CurrentURL";
import usePointsStore from "../StatesStore/PointsTable";
function SignIn() {
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get("ref");
  const url = useUrlState((state) => state.url);
  const redirectUser = useNavigate();
  const { setUser, createId } = useUserStore(); //for storing user
  const [values, setValues] = useState({
    email: "",
    pass: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState({
    email: "",
    pass: "",
  });
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const pointsTable = usePointsStore((state) => state.pointsTable);
  const { user } = UserAuth();
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  googleProvider.addScope("email");
  facebookProvider.addScope("email");
  const googleLogoPath =
    process.env.PUBLIC_URL + "/assets/images/logo/google-logo.svg";
  const facebookLogoPath =
    process.env.PUBLIC_URL + "/assets/images/logo/facebook-logo.svg";
  // const microsoftLogoPath =
  //   process.env.PUBLIC_URL + "/assets/images/logo/microsoft-logo.svg";
  // const appleLogoBlackPath =
  //   process.env.PUBLIC_URL + "/assets/images/logo/apple-logo-black.svg";
  // const appleLogoWhitePath =
  //   process.env.PUBLIC_URL + "/assets/images/logo/apple-logo-white.svg";
  useEffect(() => {
    if (user) {
      redirectUser("/");
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const storedRememberMe = localStorage.getItem("rememberMe");
    const storedRememberedEmail = localStorage.getItem("rememberedEmail");

    if (storedRememberMe) {
      setRememberMe(JSON.parse(storedRememberMe));
    }

    if (storedRememberMe && storedRememberedEmail) {
      setValues((prevValues) => ({
        ...prevValues,
        email: JSON.parse(storedRememberedEmail),
      }));
    }

    WebFont.load({
      google: {
        families: ["Nunito Sans", "sans-serif"],
      },
    });
  }, []);

  const updateRememberMe = () => {
    if (rememberMe) {
      localStorage.setItem("rememberMe", JSON.stringify(true));
      localStorage.setItem("rememberedEmail", JSON.stringify(values.email));
    } else {
      localStorage.removeItem("rememberMe");
      localStorage.removeItem("rememberedEmail");
    }
  };

  const isEmailValid = (email) => {
    // Add your email validation logic here
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmission = async () => {
    setLoading(true);
    setErrorMsg({
      email: "",
      pass: "",
    });

    if (!values.email) {
      setErrorMsg((prevErrors) => ({
        ...prevErrors,
        email: "Email is required",
      }));
      setLoading(false);
      return;
    } else if (!isEmailValid(values.email)) {
      setErrorMsg((prevErrors) => ({
        ...prevErrors,
        email: "Invalid email format",
      }));
      setLoading(false);
      return;
    } else if (!values.pass) {
      setErrorMsg((prevErrors) => ({
        ...prevErrors,
        pass: "Password is required",
      }));
      setLoading(false);
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, values.email, values.pass);
      const currentUser = auth.currentUser;
      console.log("currentUser", currentUser);
      if (currentUser && !currentUser.displayName) {
        const displayName = "DefaultDisplayName";
        await updateProfile(currentUser, { displayName });
      }

      updateRememberMe();
      if (!currentUser.emailVerified) {
        redirectUser("/VerifyEmail");
      } else {
        redirectUser(url);
      }
    } catch (error) {
      setErrorMsg((prevErrors) => ({
        ...prevErrors,
        // email: "Invalid email or password",
        pass: "Invalid email or password",
      }));
      setLoading(false);
    }
  };

  const googleSignIn = async () => {
    try {
      setLoading(true);
      const result = await signInWithPopup(auth, googleProvider);
      console.log("result", result);
      return result;
    } catch (error) {
      setLoading(false);
      throw error;
    }
  };
  const facebookSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, facebookProvider);
      console.log(result.user);
      return result;
    } catch (error) {
      if (error.code === "auth/account-exists-with-different-credential") {
        const pendingCred = FacebookAuthProvider.credentialFromError(error);
        const email = error.customData.email;
        const signInMethods = await fetchSignInMethodsForEmail(auth, email);
        console.log(signInMethods);
        if (signInMethods.includes("google.com")) {
          try {
            alert(
              "Account with this email " +
                email +
                " already exists. You need to login with gmail first in order to link both accounts"
            );
            const userCredential = await signInWithPopup(auth, googleProvider);
            await linkWithCredential(userCredential.user, pendingCred);
            console.log("Successfully linked existing account with Facebook");
          } catch (linkError) {
            console.error("Error linking credential:", linkError);
          }
        } else if (signInMethods.includes("password")) {
          try {
            const password = prompt(
              "Account with this email " +
                email +
                " already existed. Enter you password in order to link both accounts:"
            );
            const userCredential = await signInWithEmailAndPassword(
              auth,
              email,
              password
            ); // No password needed
            await linkWithCredential(userCredential.user, pendingCred);
            console.log("Successfully linked existing account with Facebook");
          } catch (linkError) {
            console.error("Error linking credential:", linkError);
          }
        } else {
          console.log("Other sign-in methods detected:", signInMethods);
          // Handle other provider linking if needed
        }
      } else {
        console.error("Error during sign-in:", error);
      }
    }
  };
  // const appleSignIn = async () => {
  //   try {
  //     const result = await signInWithPopup(auth, appleProvider);
  //     return result;
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true);
      const result = await googleSignIn();
      // console.time("handleGoogleSignIn");

      if (!result?.user) {
        throw new Error("No user found in Google sign-in result");
      }

      const { user } = result;
      const db = getFirestore();
      const userRef = doc(db, "users", user.uid);

      user.emailVerified = true;
      user.email = user.providerData[0]?.email || user.email;

      createId(user.uid);

      if (!user.displayName) {
        await updateProfile(user, { displayName: "DefaultDisplayName" });
      }

      // Update email verification in backend
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}/api/updateEmailVerified`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ uid: user.uid }),
          }
        );
        const data = await response.json();
        console.log("Email verified Response", data);
      } catch (err) {
        console.error("Email verified Catch", err);
      }

      const docSnap = await getDoc(userRef);

      // Handle New User
      if (!docSnap.exists()) {
        await WelcomeUser(user.displayName, user.email);
        auth.currentUser.emailVerified = true;

        const referralCode = generateReferralCode();
        const displayNameParts = (
          user.displayName || "DefaultDisplayName"
        ).split(" ");

        const newUser = {
          userName: user.displayName || "DefaultDisplayName",
          email: user.email,
          firstName: displayNameParts[0] || null,
          lastName: displayNameParts.slice(1).join(" ") || null,
          birthday: user.birthday || null,
          phoneNumber: user.phoneNumber || null,
          gender: user.gender || null,
          photo: user.photoURL || null,
          overview: user.overview || null,
          products: user.products || null,
          timestamp: serverTimestamp(),
          location: null,
          userTitle: null,
          requstList: user.requestList || [],
          followingList: user.followingList || [],
          followerList: user.followerList || [],
          friendRequests: user.friendRequests || {},
          post: user.post || {},
          shoppinglist: user.shoppinglist || {},
          terms: false,
          heardAboutUs: "",
          referralCode,
          isVerified: true,
        };

        handleInvite(inviteCode, user.uid, user.email, pointsTable);

        await setUser(newUser);
        await setDoc(userRef, newUser);

        toast.success("Sign in with Google successful!", toastOptions);
        return redirectUser("/SignInInput");
      }

      // Existing User
      if (!user.gender || !user.birthday) {
        return redirectUser("/SignInInput");
      }

      return redirectUser(url);
    } catch (error) {
      console.error("Error during Google sign-in:", error);
      setLoading(false);

      switch (error.code) {
        case "auth/popup-closed-by-user":
          return redirectUser("/SignIn");
        case "auth/cancelled-popup-request":
          return console.error("Popup request cancelled");
        default:
          toast.error("Google Sign-In failed. Please try again.", toastOptions);
          return redirectUser("/SignIn");
      }
    } finally {
      setLoading(false);
      // console.timeEnd("handleGoogleSignIn");
    }
  };

  const handleFacebookSignIn = async () => {
    setLoading(true);
    try {
      const result = await facebookSignIn();
      console.log(result);
      // Check if the result is defined and has a 'user' property
      if (result && result.user) {
        // Extract user information from the Google sign-in result
        const { user } = result;
        if (user) {
          console.log("user facebook", user);
          user.emailVerified = true;
          user.email = user.providerData[0].email;
          createId(user.uid);
          if (!user.displayName) {
            const displayName = "DefaultDisplayName";
            await updateProfile(user, { displayName });
          }

          // Store user information in Firestore
          const db = getFirestore();
          const userRef = doc(db, "users", user.uid);

          // Check if the user already exists in Firestore
          const docSnap = await getDoc(userRef);
          console.log("here ser facebook", user);
          //new user
          if (!docSnap.exists()) {
            await WelcomeUser(user.displayName, user.providerData[0]?.email);
            fetch(process.env.REACT_APP_API + "/api/updateEmailVerified", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ uid: user.uid }),
            });
            auth.currentUser.emailVerified = true;
            const referralCode = generateReferralCode();
            const displayNameParts = (
              user.displayName || "DefaultDisplayName"
            ).split(" ");
            //make user dictionary
            const newUser = {
              userName: user.displayName || "DefaultDisplayName",
              email: user.email,
              firstName: displayNameParts[0] || null,
              lastName: displayNameParts.slice(1).join(" ") || null,
              birthday: user.birthday || null,
              phoneNumber: user.phoneNumber || null,
              gender: user.gender || null,
              photo: user.photoURL || null,
              overview: user.overview || null,
              products: user.products || null,
              timestamp: serverTimestamp(),
              location: null,
              userTitle: null,
              requestList: user.requestList || [],
              followingList: user.followingList || [],
              followerList: user.followerList || [],
              friendRequests: user.friendRequests || {},
              post: user.post || {},
              shoppinglist: user.shoppinglist || {},
              terms: false, //adding this to users object in firestore
              heardAboutUs: "",
              referralCode: referralCode,
              isVerified: true,
            };
            handleInvite(inviteCode, user.uid, user.email, pointsTable);
            //user has no gender or birthday
            //save the state of user
            await setUser(newUser);
            //set document in firestore here
            await setDoc(userRef, newUser);
            //redirect to gender/birthday compoennt
            try {
              toast.success("Sign in with Facebook successfull!", toastOptions);
              //redirect to more questions
              redirectUser("/SignInInput");
            } catch (error) {
              console.log("Error Signing in");
              toast.error("Sign up failed. Please try again.", toastOptions);
              redirect("/SignIn");
            }
          } else {
            redirectUser(url);
          }
        }
      }
    } catch (error) {
      console.error("Error during Facebook sign-in:", error);
      if (error.code === "auth/popup-closed-by-user") {
        // alert("Facebook Sign-In popup closed. Please try again.");
        redirectUser("/login");
      } else if (error.code === "auth/cancelled-popup-request") {
        console.error(error);
        // alert("Facebook Sign-In request cancelled. Please try again.");
      } else {
        console.error(error);
        // alert("Facebook Sign-In failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // const handleAppleSignIn = async () => {
  //   try {
  //     const result = await appleSignIn();
  //     console.log(result);
  //     // Check if the result is defined and has a 'user' property
  //     if (result && result.user) {
  //       // Extract user information from the Google sign-in result
  //       const { user } = result;
  //       if (user) {
  //         console.log("user apple", user);
  //         createId(user.uid);
  //         if (!user.displayName) {
  //           const displayName = "DefaultDisplayName";
  //           await updateProfile(user, { displayName });
  //         }

  //         // Store user information in Firestore
  //         const db = getFirestore();
  //         const userRef = doc(db, "users", user.uid);

  //         // Check if the user already exists in Firestore
  //         const docSnap = await getDoc(userRef);
  //         console.log("here ser facebook", user);
  //         //new user
  //         if (!docSnap.exists()) {
  //           await WelcomeUser(user.displayName, user.providerData[0]?.email);
  //           await fetch(
  //             "https://us-central1-duplookflock-beada.cloudfunctions.net/api/api/updateEmailVerified",
  //             {
  //               method: "POST",
  //               headers: {
  //                 "Content-Type": "application/json",
  //               },
  //               body: JSON.stringify({ uid: user.uid }),
  //             }
  //           );
  //           auth.currentUser.emailVerified = true;
  //           const referralCode = generateReferralCode();
  //           const displayNameParts = (
  //             user.displayName || "DefaultDisplayName"
  //           ).split(" ");
  //           //make user dictionary
  //           const newUser = {
  //             userName: user.displayName || "DefaultDisplayName",
  //             email: user.email,
  //             firstName: displayNameParts[0] || null,
  //             lastName: displayNameParts.slice(1).join(" ") || null,
  //             birthday: user.birthday || null,
  //             phoneNumber: user.phoneNumber || null,
  //             gender: user.gender || null,
  //             photo: user.photoURL || null,
  //             overview: user.overview || null,
  //             products: user.products || null,
  //             timestamp: serverTimestamp(),
  //             location: null,
  //             userTitle: null,
  //             requestList: user.requestList || [],
  //             followingList: user.followingList || [],
  //             followerList: user.followerList || [],
  //             friendRequests: user.friendRequests || {},
  //             post: user.post || {},
  //             shoppinglist: user.shoppinglist || {},
  //             terms: false, //adding this to users object in firestore
  //             heardAboutUs: "",
  //             referralCode: referralCode,
  //             isVerified: true,
  //           };
  //           handleInvite(inviteCode, user.uid, user.email);
  //           //user has no gender or birthday
  //             //save the state of user
  //             setUser(newUser);
  //             //set document in firestore here
  //             await setDoc(userRef, newUser);
  //             try {
  //               //redirect to more questions
  //               redirectUser("/SignInInput");
  //             } catch (error) {
  //               console.log("Error Signing in");
  //               toast.error("Sign up failed. Please try again.", toastOptions);
  //               redirect("/SignIn");
  //             }
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error during Facebook sign-in:", error);
  //     if (error.code === "auth/popup-closed-by-user") {
  //       // alert("Facebook Sign-In popup closed. Please try again.");
  //       redirectUser("/login");
  //     } else if (error.code === "auth/cancelled-popup-request") {
  //       console.error(error);
  //       // alert("Facebook Sign-In request cancelled. Please try again.");
  //     } else {
  //       console.error(error);
  //       // alert("Facebook Sign-In failed. Please try again.");
  //     }
  //   }
  // };

  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Nunito Sans", "sans-serif", "inter"],
      },
    });
  }, []);

  useEffect(() => {
    const storedRememberMe = localStorage.getItem("rememberMe");
    const storedRememberedEmail = localStorage.getItem("rememberedEmail");

    if (storedRememberMe) {
      setRememberMe(JSON.parse(storedRememberMe));
    }

    if (storedRememberMe && storedRememberedEmail) {
      setValues((prevValues) => ({
        ...prevValues,
        email: JSON.parse(storedRememberedEmail),
      }));
    }
  }, []);
  useEffect(() => {
    if (user) {
      // If user exists, navigate to the desired location
      // redirectUser("/");
    } else {
      redirectUser("/SignIn");
    }
  }, []);

  return (
    <>
      <div className="container ">
        <div className="row justify-content-center align-items-center vh-100 py-2 ">
          <div className="col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-5">
            <div
              className="rounded-3"
              style={{
                backgroundColor: "white",
                padding: `1.5rem ${isSmallScreen ? "2rem" : "3.5rem"}`,
              }}
            >
              <div
                className="text-center mb-4"
                style={{ lineHeight: "0.5rem" }}
              >
                <h3
                  style={{
                    fontFamily: "Playfair Display",
                    fontWeight: 600,
                    fontSize: "1.85rem",
                  }}
                >
                  Welcome to Lookflock
                </h3>
                <p
                  style={{
                    fontFamily: "Open Sans",
                    fontWeight: 400,
                    fontSize: "1rem",
                  }}
                >
                  Find new fashion ideas to try
                </p>
              </div>
              <div className="d-flex flex-column gap-2">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmission(e);
                  }}
                  className="d-flex flex-column gap-2"
                >
                  <div>
                    <label
                      htmlFor="emailInput"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                      }}
                    >
                      Email address
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="emailInput"
                      value={values.email}
                      onChange={(event) => {
                        setValues((prevValues) => ({
                          ...prevValues,
                          email: event.target.value,
                        }));
                        setErrorMsg((prevErrors) => ({
                          ...prevErrors,
                          email: "",
                        }));
                      }}
                      className="form-control rounded-3"
                      placeholder="Email"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "1rem",
                        width: "100%",
                      }}
                      required
                    />
                  </div>
                  <div className="position-relative">
                    <label
                      htmlFor="passwordInput"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "0.8rem",
                        marginBottom: "0rem",
                      }}
                    >
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      value={values.pass}
                      onChange={(event) => {
                        setValues((prevValues) => ({
                          ...prevValues,
                          pass: event.target.value,
                        }));
                        setErrorMsg((prevErrors) => ({
                          ...prevErrors,
                          pass: "",
                        }));
                      }}
                      id="passwordInput"
                      className="form-control rounded-3"
                      placeholder="Password"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                        fontSize: "1rem",
                        width: "100%",
                      }}
                      required
                    />
                    <button
                      type="button"
                      className="btn position-absolute end-0 translate-middle-y"
                      style={{ zIndex: 1, top: "2.75rem" }}
                      onClick={() => setShowPassword((prevState) => !prevState)}
                    >
                      <i
                        className={`bi bi-${
                          showPassword ? "eye-slash-fill" : "eye-fill"
                        }`}
                        style={{ fontSize: "1rem" }}
                      ></i>
                    </button>
                    <div
                      style={{
                        color: "red",
                        fontSize: "0.8rem",
                        fontFamily: "Open Sans",
                        fontWeight: 400,
                      }}
                    >
                      {errorMsg.pass}
                    </div>
                  </div>
                  <div className="d-sm-flex justify-content-between">
                    <div className="form-check d-flex align-items-center gap-1 p-0">
                      <input
                        type="checkbox"
                        id="rememberMe"
                        checked={rememberMe}
                        onChange={() => {
                          setRememberMe(!rememberMe);
                          updateRememberMe();
                        }}
                        style={{
                          height: "14px",
                          width: "14px",
                          cursor: "pointer",
                        }}
                      />
                      <label
                        style={{
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          fontSize: "0.9rem",
                          cursor: "pointer",
                        }}
                        className="form-check-label"
                        htmlFor="rememberMe"
                      >
                        Remember Me
                      </label>
                    </div>
                    <Link to="/Reset">
                      <u
                        className="text-body"
                        style={{
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          fontSize: "0.8rem",
                        }}
                      >
                        Forgot password?
                      </u>
                    </Link>
                  </div>
                  <div>
                    {loading ? (
                      <div
                        className="btn rounded-3 mt-1 py-2"
                        style={{
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          fontSize: "1rem",
                          width: "100%",
                          backgroundColor: "#005FDA",
                          color: "white",
                          cursor: "default",
                          opacity: "0.65",
                        }}
                      >
                        <div
                          className="spinner-border text-white"
                          style={{ width: "1rem", height: "1rem" }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <button
                        type="submit"
                        className="btn rounded-3 mt-1 py-2"
                        style={{
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          fontSize: "1rem",
                          width: "100%",
                          backgroundColor: "#005FDA",
                          color: "white",
                        }}
                      >
                        {loading ? (
                          <div
                            className="spinner-border text-white"
                            style={{ width: "1rem", height: "1rem" }}
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          "Sign In"
                        )}
                      </button>
                    )}
                  </div>
                </form>

                <div
                  className="text-center"
                  style={{ fontFamily: "Open Sans", fontWeight: 600 }}
                >
                  OR
                </div>
                <div className="d-flex justify-content-center align-items-center gap-3">
                  <button
                    type="submit"
                    className="btn pt-0"
                    onClick={() => {
                      setLoading(true);
                      handleGoogleSignIn();
                    }}
                    style={{
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      fontSize: "1rem",
                    }}
                  >
                    <img
                      src={googleLogoPath}
                      className="mx-1"
                      alt="Google"
                      style={{
                        width: "35px",
                        height: "35px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </button>
                  <button
                    type="submit"
                    className="btn pt-0"
                    onClick={handleFacebookSignIn}
                    style={{
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      fontSize: "1rem",
                    }}
                  >
                    <img
                      src={facebookLogoPath}
                      className="mx-1"
                      alt="Google"
                      style={{
                        width: "35px",
                        height: "35px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </button>
                </div>
                <TermsAndConditions />
                <p
                  className="text-center px-4 m-0"
                  style={{
                    fontFamily: "Open Sans",
                    fontWeight: 600,
                    fontSize: "0.75rem",
                  }}
                >
                  Don't have an account?{" "}
                  <Link
                    style={{ color: "black", textDecoration: "underline" }}
                    to="/SignUp"
                  >
                    Sign Up
                  </Link>
                </p>
                <p
                  className="text-center px-0 m-0"
                  style={{
                    fontFamily: "Open Sans",
                    fontWeight: 400,
                    fontSize: "0.7rem",
                  }}
                >
                  ©2025 Lookflock. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignIn;
